import { forEach, isEmpty, isNil, sortBy } from 'lodash'

const transformListToTree = listOfNodes => {
  const sortedListOfNodes = sortBy(listOfNodes, 'level')
  const nodesMap = {}
  const roots = []

  forEach(sortedListOfNodes, node => {
    const currentNode = { ...node, children: [] }
    const { id, parentId } = currentNode

    nodesMap[id] = currentNode

    if (!isNil(nodesMap[parentId])) {
      nodesMap[parentId].children.push(currentNode)
    } else {
      roots.push(currentNode)
    }
  })

  if (isEmpty(roots)) {
    return []
  }

  return roots
}

export default transformListToTree
